export default __webpack_public_path__ + "static/media/natu.bb5a36e8.jpeg";